export default class ProgressModel {
    constructor(userModel, levelModel, tierVideoModel) {
        this.userModel = userModel,
            this.levelModel = levelModel,
            this.tierVideoModel = tierVideoModel
    }
}